import { volatility } from "components/templates/w/b2b/type/Widget";
import { usePortfolioVar } from "utils/clientAPIs/portfolio";
import moment from "moment-timezone";
import { useEffect, useState } from "react";

const usePortfolioRiskUtil = (portId: number) => {
    const [hashId, setHashId] = useState<string | null | undefined>(undefined);
    const { data, isLoading, isError } = usePortfolioVar(Number(portId), hashId);
    useEffect(() => {
        const hashId = localStorage.getItem('pf-hashId');
        setHashId(hashId ?? null);
    }, []);

    // 포트폴리오 변동성 
    const portRisk = data?.portRisk ? {
        ...data.portRisk,
        EXP_CVaRNTS: Number((data.portRisk?.EXP_CVaRNTS).toFixed(1)),
        EXP_CVaRET: Number((data.portRisk?.EXP_CVaRET).toFixed(1)),
        volatility: (Number((data.portRisk?.EXP_CVaRNTS).toFixed(1)) + Number((data.portRisk?.EXP_CVaRET).toFixed(1))).toFixed(1)
    } : undefined;

    // 개별 종목 변동성
    const stockRisk = data?.stockRisk ? data?.stockRisk?.map((item: any) => ({
        ...item,
        EXP_CVaRNTS: Number(item.EXP_CVaRNTS_95.toFixed(1)),
        EXP_CVaRET: Number(item.EXP_CVaRET_95.toFixed(1)),
        volatility: !!item.EXP_CVaRNTS_95 && !!item.EXP_CVaRET_95 ? (Number(item.EXP_CVaRNTS_95.toFixed(1)) + Number(item.EXP_CVaRET_95.toFixed(1))).toFixed(1) : null

    })) : undefined;

    const maxBaseDt = portRisk ? moment(portRisk?.BASE_DT).format("M월 D일") : null;

    // 포트폴리오 비중

    return { stockRisk, portRisk, maxBaseDt, isLoading, isError, weight: data?.weight, isSameWeight: data?.isSameWeight };
};

export default usePortfolioRiskUtil;